module.exports = __webpack_public_path__ + "static/img/arrow-leaned.aa38de16.svg";